import React, { useState, useEffect } from "react";
import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/database";
import { Context } from "../backend/context";

import { Link, withRouter } from "react-router-dom";
import { Redirect } from "react-router";
import { connect } from "react-redux";

const CoinGecko = require("coingecko-api");
const CoinGeckoClient = new CoinGecko();

function CreateBotAdvanced(props) {
  const {
    uid,
    isLoggedIn,
    user,
    api_key,
    isProUser,
    isProPlusUser,
    alert,
    isRestricted,
    binance_api_key,
    kucoin_api_key,
  } = React.useContext(Context);
  const [type, setType] = useState("BUY");
  const [dcaOrGrid, setDcaOrGrid] = useState("DCA");
  const [market, setMarket] = useState("btc_usdc");
  const [strategy, setStrategy] = useState("makerBot");
  const [interval, setInterval] = useState("1m");
  const [limit, setLimit] = useState(14);
  const [threshold, setThreshold] = useState(30);
  const [arbitragePres, setArbitragePres] = useState(0.1);
  const [orderSize, setOrderSize] = useState(0);
  const [holdAmount, setHoldAmount] = useState(0);
  const [quoteAssetBinance, setQuoteAssetBinance] = useState("usdt");
  const [marketData, setMarketData] = useState({
    minOrder: 15,
    quoteAsset: "usdc",
    maxOrder: 100000,
    baseAsset: "btc",
  });
  const [takeProfit, setTakeProfit] = useState(0.3);
  const [multiplier, setMultiplier] = useState(1);
  const [maxExtraOrders, setMaxExOrders] = useState(3);
  const [activeExtraOrders, setActiveExOrders] = useState(1);
  const [stepOfExtraOrder, setStepExOrder] = useState(1);
  const [stopLoss, setStopLoss] = useState(5);
  const [isStopLossSet, setIsStopLossSet] = useState(false);
  const [submitType, setSubmitType] = useState("start");
  const [name, setName] = useState("");
  const [maxOrderSize, setMaxOrderSize] = useState(100000);

  const [maxBuy, setmaxBuy] = useState(1000);
  const [isTaker, setisTaker] = useState(true);
  const [takerArbitragePres, settakerArbitragePres] = useState(0.13);
  const [sellArbitragePres, setSellArbitragePres] = useState(0.07);
  const [sellTakerArbitragePres, setSellTakerArbitragePres] = useState(0.1);
  const [isSellAfterBuy, setSellAfterBuy] = useState(false);

  const [currencyPrice, setCurrencyPrice] = useState(0);

  var exdata = [
    {
      symbolB: "ETH/USDC",
      symbol: "eth_usdc",
      tradingAsset: "base",
      baseAsset: "eth",
      quoteAsset: "usdc",
      tickDigits: 100,
      minOrder: 15,
      maxOrder: 2000,
      coingeckoId: "ethereum",
      coingeckoConvertedAsset: "usd",
    },
    {
      symbolB: "BTC/USDC",
      symbol: "btc_usdc",
      tradingAsset: "base",
      baseAsset: "btc",
      quoteAsset: "usdc",
      tickDigits: 10,
      minOrder: 15,
      maxOrder: 2000,
      coingeckoId: "bitcoin",
      coingeckoConvertedAsset: "usd",
    },
    {
      symbolB: "NEO/USDC",
      symbol: "neo_usdc",
      tradingAsset: "base",
      baseAsset: "neo",
      quoteAsset: "usdc",
      tickDigits: 100,
      minOrder: 20,
      maxOrder: 2000,
      coingeckoId: "neo",
      coingeckoConvertedAsset: "usd",
    },
    {
      symbolB: "ETH/BTC",
      symbol: "eth_btc",
      tradingAsset: "base",
      baseAsset: "eth",
      quoteAsset: "btc",
      tickDigits: 10000000,
      minOrder: 0.0011,
      maxOrder: 0.3,
      coingeckoId: "ethereum",
      coingeckoConvertedAsset: "btc",
    },

    {
      symbolB: "LINK/USDC",
      symbol: "link_usdc",
      tradingAsset: "base",
      baseAsset: "link",
      quoteAsset: "usdc",
      tickDigits: 10000,
      minOrder: 30,
      maxOrder: 2000,
      coingeckoId: "chainlink",
      coingeckoConvertedAsset: "usd",
    },

    {
      symbolB: "NOIA/BTC",
      symbol: "noia_btc",
      tradingAsset: "base",
      baseAsset: "noia",
      quoteAsset: "btc",
      tickDigits: 100000000,
      minOrder: 0.0011,
      maxOrder: 0.3,
      coingeckoId: "noia-network",
      coingeckoConvertedAsset: "btc",
    },
    {
      symbolB: "NOIA/USDC",
      symbol: "noia_usdc",
      tradingAsset: "base",
      baseAsset: "noia",
      quoteAsset: "usdc",
      tickDigits: 100000,
      minOrder: 15,
      maxOrder: 2000,
      coingeckoId: "noia-network",
      coingeckoConvertedAsset: "usd",
    },
  ];

  const getTotalCapital = () => {
    var total = parseFloat(orderSize);
    // console.log(maxExtraOrders);
    for (let index = 1; index < parseFloat(maxExtraOrders) + 1; index++) {
      total += parseFloat(orderSize) * parseFloat(multiplier) ** index;
      // console.log(parseFloat(orderSize) * parseFloat(multiplier) ** index);
    }
    if (type === "BUY" && marketData.quoteAsset === "usdc") {
      total = parseFloat(total.toFixed(2));
    } else if (type === "BUY") {
      total = parseFloat(total.toFixed(6));
    } else {
      total = parseFloat((total / currencyPrice).toFixed(6));
    }

    return total;
  };

  const getPrices = async (data) => {
    let coinData = await CoinGeckoClient.coins.fetchTickers(data.coingeckoId, {
      order: CoinGecko.ORDER.VOLUME_DESC,
    });

    setCurrencyPrice(
      coinData.data.tickers[0].converted_last[data.coingeckoConvertedAsset]
    );
  };

  const getSymbolData = (symbol) => {
    var symbolD = {};
    exdata.forEach((element) => {
      if (element.symbol === symbol) {
        symbolD = element;
        return;
      }
    });
    return symbolD;
  };

  useEffect(() => {
    const data = getSymbolData(market);
    setMarketData(data);
    setOrderSize(data.minOrder);
    if (
      market === "gunthy_btc" ||
      ((market === "noia_btc" || market === "noia_usdc") &&
        !(strategy === "MARKET-MAKER" || strategy === "KUCOIN-ARB"))
    ) {
      setStrategy("makerBot");
    } else if (strategy === "MARKET-MAKER" && market === "gunthy_btc") {
      setStrategy("makerBot");
    }
    getPrices(data);
    if (strategy === "MARKET-MAKER") {
      setTakeProfit(3);
    } else if (strategy === "EMA-MA-CROSSOVER") {
      setTakeProfit(5);
    } else {
      setTakeProfit(0.3);
    }
  }, [market, strategy]);

  useEffect(() => {
    if (strategy === "bband" || strategy === "RSI") {
      setLimit(14);
    } else {
      setLimit(6);
    }
    if (strategy === "BINANCE-ARB" || strategy === "KUCOIN-ARB") {
      setMaxOrderSize(marketData.maxOrder);
    } else {
      setMaxOrderSize(100000);
    }
    if (strategy === "EMA-MA-CROSSOVER") {
      setMaxExOrders(0);
    }
  }, [strategy, marketData]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (submitType === "start" && !isRestricted) {
      let data = {
        name: name,
        type: type,
        market: market,
        dcaOrGrid: dcaOrGrid,
        strategy: {
          name: strategy,
          interval: interval,
          limit: parseInt(limit),
          threshold: parseFloat(threshold),
          arbitragePres: parseFloat(arbitragePres),
          isTaker: isTaker,
          takerArb: parseFloat(takerArbitragePres),
          maxBuy: parseFloat(maxBuy),
          sellTakerArbitragePres: parseFloat(sellTakerArbitragePres),
          sellArbitragePres: parseFloat(sellArbitragePres),
          isSellAfterBuy: isSellAfterBuy,
        },
        orderSize: parseFloat(orderSize),
        holdAmount: parseFloat(holdAmount),
        quoteAssetBinance: quoteAssetBinance,
        createdAt: Date.now(),
        takeProfit: parseFloat(takeProfit),
        maxExtraOrders: parseFloat(maxExtraOrders),
        activeExtraOrders: parseFloat(activeExtraOrders),
        stepOfExtraOrder: parseFloat(stepOfExtraOrder),
        stopLoss: parseFloat(stopLoss),
        multiplier: parseFloat(multiplier),
        isStopLossSet: isStopLossSet,
        uid: uid,
        isRunning: false,
        isDeleted: false,
        stopAfterDealComplete: false,
        isPending: true,
        processID: "",
        displayId: (props.botsCount + 100000).toString(),
      };
      firebase
        .firestore()
        .collection("pendingBots")
        .add(data)
        .then((ref) => {
          var botsCountRef = firebase.database().ref("botsCount").push();

          botsCountRef.set({
            displayId: (props.botsCount + 100000).toString(),
          });
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      let data = {
        name: name,
        type: type,
        market: market,
        dcaOrGrid: dcaOrGrid,
        strategy: {
          name: strategy,
          interval: interval,
          limit: parseInt(limit),
          threshold: parseFloat(threshold),
          arbitragePres: parseFloat(arbitragePres),
          isTaker: isTaker,
          takerArb: parseFloat(takerArbitragePres),
          maxBuy: parseFloat(maxBuy),
          sellTakerArbitragePres: parseFloat(sellTakerArbitragePres),
          sellArbitragePres: parseFloat(sellArbitragePres),
          isSellAfterBuy: isSellAfterBuy,
        },
        orderSize: parseFloat(orderSize),
        holdAmount: parseFloat(holdAmount),
        quoteAssetBinance: quoteAssetBinance,
        createdAt: Date.now(),
        takeProfit: parseFloat(takeProfit),
        maxExtraOrders: parseFloat(maxExtraOrders),
        activeExtraOrders: parseFloat(activeExtraOrders),
        stepOfExtraOrder: parseFloat(stepOfExtraOrder),
        stopLoss: parseFloat(stopLoss),
        multiplier: parseFloat(multiplier),
        isStopLossSet: isStopLossSet,
        uid: uid,
        isRunning: false,
        isDeleted: false,
        stopAfterDealComplete: false,
        isPending: false,
        processID: "",
        displayId: (props.botsCount + 100000).toString(),
      };
      firebase
        .firestore()
        .collection("bots")
        .add(data)
        .then((ref) => {
          var botsCountRef = firebase.database().ref("botsCount").push();

          botsCountRef.set({
            displayId: (props.botsCount + 100000).toString(),
          });
        })
        .catch((err) => {
          console.log(err);
        });
    }

    props.history.push("/account");
  };

  return (
    <div className="py-5 container text-left badge-dark">
      {!isLoggedIn || !user ? <Redirect to="/" /> : null}
      {api_key.length < 5 ? <Redirect to="/account" /> : null}
      {alert.isAvailable && (
        <div className="row">
          <div
            className={"col-11 m-auto text-center alert alert-" + alert.type}
          >
            {alert.msg}
          </div>
        </div>
      )}

      <div className="row">
        <div className="col-12 h3 pt-3 text-center">
          Create New Bot - Advanced
        </div>
      </div>
      <div className="row">
        <div className="col-11 col-sm-8 m-auto ">
          <form onSubmit={handleSubmit}>
            <div className="form-group row mt-3 ">
              <label className="col-6 col-form-label">Name</label>
              <div className="col-6">
                <input
                  onChange={(e) => {
                    setName(e.target.value);
                  }}
                  type="text"
                  className="form-control"
                  value={name}
                />
              </div>
            </div>
            {strategy !== "MARKET-MAKER" &&
              strategy !== "MARKET-MAKER-RSI" &&
              strategy !== "EMA-MA-CROSSOVER" && (
                <div className="form-group row mt-3 ">
                  <label className="col-6 col-form-label tooltipMy">
                    Trend{" "}
                    <span role="img" aria-label="info">
                      &#10068;
                    </span>
                    <div className="tooltiptextmy">
                      <span>
                        <strong>UP (BUY) -</strong> After a BUY Signal trigger,
                        bot will place BUY order first and if it fill bot create
                        take profit sell order for that. Ex:- To run BUY bot on
                        BTC/USDC market you need USDC in your account.
                        <br />
                        <br />
                        <strong>Down (SELL) -</strong> After a SELL Signal
                        trigger, bot will place SELL order first and if it fill
                        bot create take profit buy order for that. Ex:- To run
                        SELL bot on BTC/USDC market you need BTC in your
                        account.
                      </span>
                    </div>
                  </label>
                  <div className="col-6">
                    <select
                      required
                      onChange={(e) => {
                        setType(e.target.value);
                      }}
                      className="custom-select mr-sm-2"
                      defaultValue={"BUY"}
                    >
                      <option value="BUY">UP (BUY)</option>
                      <option value="SELL">Down (SELL)</option>
                    </select>
                  </div>
                </div>
              )}
            <div className="form-group row">
              <label className="col-6 col-form-label">Market</label>
              <div className="col-6">
                <select
                  required
                  onChange={(e) => {
                    setMarket(e.target.value);
                  }}
                  className="custom-select mr-sm-2"
                  defaultValue="btc_usdc"
                >
                  {exdata.map((item, key) => (
                    <option key={key} value={item.symbol}>
                      {item.symbolB}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="form-group row">
              <label className="col-7 col-sm-6 col-form-label tooltipMy">
                {strategy === "BINANCE-ARB" ||
                strategy === "KUCOIN-ARB" ||
                strategy === "MARKET-MAKER" ||
                strategy === "MARKET-MAKER-RSI" ||
                strategy === "EMA-MA-CROSSOVER"
                  ? "Max "
                  : ""}{" "}
                Order Size ({marketData.quoteAsset.toUpperCase()}){" "}
                <span role="img" aria-label="info">
                  &#10068;
                </span>
                <div className="tooltiptextmy">
                  <span>
                    Order size for your one order.
                    <br />
                    If your type SELL, order size $10 and market is BTC/USDC you
                    need $10 worth BTC in your account. If you set 3 extra
                    orders you need $40 worth of BTC available in your account.
                  </span>
                </div>
              </label>
              <div className="col-5 col-sm-6">
                <input
                  required
                  onChange={(e) => {
                    setOrderSize(e.target.value);
                  }}
                  type="number"
                  step="0.0001"
                  className="form-control"
                  min={marketData.minOrder}
                  value={orderSize}
                  max={maxOrderSize}
                />
              </div>
            </div>
            <div className="form-group row mb-4">
              <label className="col-6 col-form-label tooltipMy">
                {strategy === "MARKET-MAKER" ||
                strategy === "MARKET-MAKER-RSI" ||
                strategy === "EMA-MA-CROSSOVER"
                  ? "Max "
                  : ""}{" "}
                Take Profit (%){" "}
                <span role="img" aria-label="info">
                  &#10068;
                </span>
                <div className="tooltiptextmy">
                  {strategy === "MARKET-MAKER" ||
                  strategy === "MARKET-MAKER-RSI" ||
                  strategy === "EMA-MA-CROSSOVER" ? (
                    <span>
                      This bots don't have fixed take profit. So anytime if sell
                      signal trigger bot will sell. <br />
                      But if price increase more than max take profit bot will
                      place taker sell order and sell all bought assets.
                    </span>
                  ) : (
                    <span>
                      If your type buy and your buy order filled bot will place
                      take profit sell order with highr price as your take
                      profit presentage.
                      <br />
                      <br />
                      Take Profit calculate excluding trading fees. Your order
                      may fill as a taker or maker. If it is filled as taker you
                      have to pay fees. So consider it when you set take profit
                      presentage.
                    </span>
                  )}
                </div>
              </label>
              <div className="col-6">
                <input
                  required
                  onChange={(e) => {
                    setTakeProfit(e.target.value);
                  }}
                  type="number"
                  step="0.0001"
                  className="form-control"
                  min="0"
                  value={takeProfit}
                />
              </div>
            </div>

            <div className="form-group row">
              <div className="col-12 border border-black rounded-lg pt-4 componentWrapper">
                <div className="header">Strategy Settings</div>
                <div className="form-group row">
                  <label className="col-6 col-form-label tooltipMy">
                    Strategy{" "}
                    <span role="img" aria-label="info">
                      &#10068;
                    </span>
                    <div className="tooltiptextmy">
                      <span>
                        <strong>Bollinger Bands -</strong> <br />
                        Bollinger bands use to trigger signals. If price drop
                        lower than lower bollinger band bot will trigger BUY
                        signal. If price increase and cross upper bollinger band
                        bot will trigger SELL signal.
                        <br />
                        <br /> <strong>RSI -</strong> <br />
                        RSI value use to trigger signals. If RSI value is
                        exiting from lower threshold range bot will place buy
                        order. If RSI value is exiting from upper threshold
                        range bot will place sell order.
                        <br />
                        If your Threshold is 30 lower range is less than 30,
                        upper range is greater than 70.
                        <br /> <br /> <strong>Maker -</strong> <br />
                        Bot will place limit order on top of the orderbook and
                        if it fill bot will place take profit order for that
                        order. <br />
                        <br /> <strong>Maker-RSI -</strong> <br />
                        <strong> Maker Bot + Risk mangement with RSI</strong>
                        <br />
                        Bot will place limit order on top of the orderbook and
                        if it fill bot will place take profit order for that
                        order. Additianlly if RSI is in threshold ranges bots
                        stop placing orders, cancel pending orders and wait
                        until rsi come to middle range.
                        <br />
                        <br /> <strong>Maker-Arbitrage -</strong> <br />
                        <strong>
                          {" "}
                          Maker Bot + Risk mangement doing by comparing Binance
                          and nash prices
                        </strong>
                        <br />
                        Bot will place limit order on top of the orderbook and
                        if it fill bot will place take profit order for that
                        order. Additianlly if price on nash has big difference
                        compare to binance price bot will stop and wait. <br />
                        Ex- If nash price is much highr than binance price buy
                        bots stop placing orders and also cancel pending orders.
                        <br />
                        <br /> <strong>Taker-Arbitrage -</strong> <br />
                        Bot will compare Binance and nash prices and trigger
                        signals. <br />
                        If nash's best ask price is less than your arbitrage
                        percentage of binance price,{" "}
                        <strong>UP (BUY) bots</strong> will place taker BUY
                        order and will place maker take profit SELL order with
                        your take profit percentage. <br />
                        If nash's best bid price is greater than your arbitrage
                        percentage of binance price,{" "}
                        <strong>Down (SELL) bots</strong> will place taker SELL
                        order and will place maker take profit BUY order with
                        your take profit percentage.
                        <br />
                        <br /> <strong>Binance-Arbitrage -</strong> <br />
                        Cross exchange arbitrage with Nash and Binance margin
                        account. <br />
                        <br /> <strong>Kucoin-Arbitrage -</strong> <br />
                        Cross exchange arbitrage with Nash and Kucoin account.{" "}
                        <br />
                        <br /> <strong>Market Maker -</strong> <br />
                        Combination of Maker-arbitage and Taker-arbitrage.{" "}
                        <br />
                        Trade on both buy and sell sides. Don't have fixed take
                        profit orders. <br />
                        <br /> <strong>Market Maker RSI -</strong> <br />
                        Trade on both buy and sell sides. Don't have fixed take
                        profit order. <br />
                        Bot will BUY if RSI value is less than 30. Bot will SELL
                        if RSI value is greater than 70.
                        <br /> RSI value calculate based on Binance charts. Time
                        interval "1m", limit 10.
                        <br /> <strong>EMA-MA-Crossover -</strong> <br />
                        Buy / Sell based on below tradingview strategy. <br />
                        <a
                          target="_blank"
                          href="https://www.tradingview.com/script/EI1DSffI-EMA-MA-Crossover/"
                        >
                          Link
                        </a>
                      </span>
                    </div>
                  </label>
                  <div className="col-6">
                    <select
                      required
                      onChange={(e) => {
                        setStrategy(e.target.value);
                      }}
                      className="custom-select mr-sm-2"
                      defaultValue={"makerBot"}
                    >
                      {
                        !(market === "gunthy_btc") && (
                          // (isProUser || isProPlusUser) && (
                          <option value="MARKET-MAKER">Market Maker </option>
                        )
                        // )
                      }
                      <option value="makerBot">Maker</option>
                      {!(
                        market === "gunthy_btc" ||
                        market === "noia_btc" ||
                        market === "noia_usdc"
                      ) && (
                        <React.Fragment>
                          <option value="MARKET-MAKER-RSI">
                            Market Maker RSI
                          </option>{" "}
                          <option value="EMA-MA-CROSSOVER">
                            EMA-MA-Crossover
                          </option>
                          <option value="bband">Bollinger Bands</option>
                          <option value="RSI">RSI</option>
                          <option value="MAKER-RSI">Maker - RSI</option>
                          <option value="MAKER-ARB">Maker - Arbitrage</option>
                          <option value="MAKER-RSI-ARB">
                            Maker-RSI-Arbitrage
                          </option>
                          <option value="TAKER-ARB">Taker - Arbitrage</option>
                        </React.Fragment>
                      )}
                      {binance_api_key.length > 0 &&
                        !(
                          market === "gunthy_btc" ||
                          market === "noia_btc" ||
                          market === "noia_usdc"
                        ) && (
                          <option value="BINANCE-ARB">
                            Binance - Arbitrage
                          </option>
                        )}
                      {kucoin_api_key.length > 0 &&
                        !(market === "gunthy_btc") && (
                          <option value="KUCOIN-ARB">Kucoin - Arbitrage</option>
                        )}
                    </select>
                  </div>
                </div>
                {(strategy === "bband" ||
                  strategy === "RSI" ||
                  strategy === "MAKER-RSI" ||
                  strategy === "MAKER-RSI-ARB" ||
                  strategy === "EMA-MA-CROSSOVER") && (
                  <div>
                    <div className="form-group row ">
                      <label className=" offset-1 col-6 col-form-label tooltipMy">
                        Interval{" "}
                        <span role="img" aria-label="info">
                          &#10068;
                        </span>
                        <div className="tooltiptextmy">
                          <span>
                            Time interval use to calculate signals.
                            <br />
                          </span>
                        </div>
                      </label>
                      <div className="col-5">
                        <select
                          required
                          onChange={(e) => {
                            setInterval(e.target.value);
                          }}
                          className="custom-select mr-sm-2"
                          defaultValue="1m"
                        >
                          <option value="1m">1m</option>
                          <option value="3m">3m</option>
                          <option value="5m">5m</option>
                          <option value="15m">15m</option>
                          <option value="30m">30m</option>
                          <option value="1h">1h</option>
                          <option value="2h">2h</option>
                          <option value="4h">4h</option>
                          <option value="6h">6h</option>
                        </select>
                      </div>
                    </div>{" "}
                    <div className="form-group row  ">
                      <label className="offset-1 col-6 col-form-label tooltipMy">
                        Limit{" "}
                        <span role="img" aria-label="info">
                          &#10068;
                        </span>
                        <div className="tooltiptextmy">
                          <span>
                            Limit means number of candles use to calculate
                            signals.
                            <br />
                            This is same as length parameter in TradingView
                            bollinger band and RSI indicators.
                            <br />
                            <br />
                            For bollinger bands - If it too low bot will not
                            trigger signals. So recommended value is a value{" "}
                            <strong>between 14-25</strong>.<br />
                            For RSI - Rrecommended value is a value{" "}
                            <strong>between 2-20</strong>.
                          </span>
                        </div>
                      </label>
                      <div className="col-5">
                        <input
                          required
                          onChange={(e) => {
                            setLimit(e.target.value);
                          }}
                          type="number"
                          className="form-control"
                          value={limit}
                          min="0"
                          max="50"
                        />
                      </div>
                    </div>
                    {(strategy === "RSI" ||
                      strategy === "MAKER-RSI" ||
                      strategy === "MAKER-RSI-ARB") && (
                      <div className="form-group row  ">
                        <label className="offset-1 col-6 col-form-label tooltipMy">
                          Threshold{" "}
                          <span role="img" aria-label="info">
                            &#10068;
                          </span>
                          <div className="tooltiptextmy">
                            <span>
                              Threshold is a RSI value which use to trigger
                              signals.
                              <br />
                              If it is 30, buy signals trigger at 30 and sell
                              signals trigger at 70.
                              <br />
                              <br />
                              Recommended value is a value{" "}
                              <strong>between 20-40</strong>.
                            </span>
                          </div>
                        </label>
                        <div className="col-5">
                          <input
                            required
                            onChange={(e) => {
                              setThreshold(e.target.value);
                            }}
                            type="number"
                            className="form-control"
                            value={threshold}
                            min="5"
                            step="0.01"
                            max="45"
                          />
                        </div>
                      </div>
                    )}
                  </div>
                )}
                {(strategy === "TAKER-ARB" ||
                  strategy === "MAKER-ARB" ||
                  strategy === "MAKER-RSI-ARB") && (
                  <div className="form-group row  ">
                    <label className="offset-1 col-6 col-form-label tooltipMy">
                      Arbitrage Percentage (%){" "}
                      <span role="img" aria-label="info">
                        &#10068;
                      </span>
                      <div className="tooltiptextmy">
                        <span>
                          Arbitrage Percentage is percentage value which use to
                          compare binance and nash prices to trigger signals.
                          <br />
                          Rrecommended value for maker bots is{" "}
                          <strong>0.1</strong>.
                          <br />
                          Rrecommended value for taker bots is{" "}
                          <strong>0.25</strong>.
                        </span>
                      </div>
                    </label>
                    <div className="col-5">
                      <input
                        required
                        onChange={(e) => {
                          setArbitragePres(e.target.value);
                        }}
                        type="number"
                        className="form-control"
                        step="0.0001"
                        value={arbitragePres}
                        min="0.0001"
                        max="100"
                      />
                    </div>
                  </div>
                )}
                {(strategy === "BINANCE-ARB" || strategy === "KUCOIN-ARB") && (
                  <div className="form-group row">
                    <label className="col-7 col-form-label tooltipMy">
                      Hold amount ({marketData.quoteAsset.toUpperCase()}){" "}
                      <span role="img" aria-label="info">
                        &#10068;
                      </span>
                      <div className="tooltiptextmy">
                        <span>
                          Binance-Arbitrage and Kucoin-Arbitrage bots keep that
                          amount free on your nash account and use only
                          additinal funds for trading.
                          <br />
                          If your type SELL, market is BTC/USDC, Hold amount
                          $100 and account has $500 worth BTC bot trade maximum
                          $400 worth BTC and keep $100 worth btc free.
                        </span>
                      </div>
                    </label>
                    <div className="col-5">
                      <input
                        onChange={(e) => {
                          setHoldAmount(e.target.value);
                        }}
                        type="number"
                        className="form-control"
                        value={holdAmount}
                        min="0"
                      />
                    </div>
                  </div>
                )}
                {(strategy === "BINANCE-ARB" || strategy === "KUCOIN-ARB") &&
                  (market === "eth_usdc" || market === "btc_usdc") && (
                    <div className="form-group row">
                      <label className="col-7 col-form-label tooltipMy">
                        {strategy === "BINANCE-ARB" ? "Binance" : "Kucoin"} USD
                        asset
                        <span role="img" aria-label="info">
                          &#10068;
                        </span>
                        <div className="tooltiptextmy">
                          <span>
                            If your Market is BTC/USDC and this value is USDC,
                            bot use{" "}
                            {strategy === "BINANCE-ARB" ? "Binance" : "Kucoin"}{" "}
                            BTC/USDC market for arbitrage trading.
                            <br />
                            If this value is USDT, bot use{" "}
                            {strategy === "BINANCE-ARB"
                              ? "Binance"
                              : "Kucoin"}{" "}
                            BTC/USDT market for arbitrage trading.
                          </span>
                        </div>
                      </label>
                      <div className="col-5">
                        <select
                          required
                          onChange={(e) => {
                            setQuoteAssetBinance(e.target.value);
                          }}
                          className="custom-select mr-sm-2"
                          defaultValue="usdt"
                        >
                          <option value="usdc">USDC</option>
                          <option value="usdt">USDT</option>
                        </select>
                      </div>
                    </div>
                  )}
                {strategy === "MARKET-MAKER" && (
                  <React.Fragment>
                    <div className="form-group row">
                      <label className="offset-1 col-6 text-left col-form-label tooltipMy ">
                        Max {marketData.baseAsset.toUpperCase()} Buy (
                        {marketData.quoteAsset.toUpperCase()})
                        <span role="img" aria-label="info">
                          &#10068;
                        </span>
                        <div className="tooltiptextmy">
                          <span>
                            Bot wouldn't buy more than that amount worth of{" "}
                            {marketData.baseAsset.toUpperCase()}.
                          </span>
                        </div>
                      </label>
                      <div className="col-5 ">
                        <input
                          required
                          onChange={(e) => {
                            setmaxBuy(e.target.value);
                          }}
                          step="0.0001"
                          type="number"
                          className="form-control"
                          value={maxBuy}
                          min="0"
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="offset-1 col-6 text-left col-form-label tooltipMy ">
                        Sell Only Buys
                        <span role="img" aria-label="info">
                          &#10068;
                        </span>
                        <div className="tooltiptextmy">
                          <span>
                            If this field checked bot wouldn't sell more than it
                            bought.
                          </span>
                        </div>
                      </label>
                      <div className="col-3 form-check p-2 pr-3 m-auto text-left">
                        <input
                          type="checkbox"
                          className="pr-3 mr-3 "
                          // style={{ fontSize: "1.5rem" }}

                          checked={isSellAfterBuy}
                          onChange={(e) => {
                            setSellAfterBuy(e.target.checked);
                          }}
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="offset-1 col-6 text-left col-form-label tooltipMy ">
                        Buy Arbitrage Percentage Maker (%)
                        <span role="img" aria-label="info">
                          &#10068;
                        </span>
                        <div className="tooltiptextmy">
                          <span>
                            If Nash price and global price gap is greater than
                            this amount bot will place maker limit buy order.{" "}
                            <br />
                          </span>
                        </div>
                      </label>
                      <div className="col-5 ">
                        <input
                          required
                          onChange={(e) => {
                            setArbitragePres(e.target.value);
                          }}
                          type="number"
                          className="form-control"
                          step="0.0001"
                          value={arbitragePres}
                          min="-100"
                          max="100"
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="offset-1 col-6 text-left col-form-label tooltipMy ">
                        Buy Arbitrage Percentage Taker (%)
                        <span role="img" aria-label="info">
                          &#10068;
                        </span>
                        <div className="tooltiptextmy">
                          <span>
                            If Nash price and global price gap is greater than
                            this amount bot will place taker limit buy order.{" "}
                            <br />
                          </span>
                        </div>
                      </label>
                      <div className="col-5 ">
                        <input
                          required
                          onChange={(e) => {
                            settakerArbitragePres(e.target.value);
                          }}
                          type="number"
                          className="form-control"
                          step="0.0001"
                          value={takerArbitragePres}
                          min="-100"
                          max="100"
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="offset-1 col-6 text-left col-form-label tooltipMy ">
                        Sell Arbitrage Percentage Maker (%)
                        <span role="img" aria-label="info">
                          &#10068;
                        </span>
                        <div className="tooltiptextmy">
                          <span>
                            If Nash price and global price gap is greater than
                            this amount bot will place maker limit sell order.{" "}
                            <br />
                          </span>
                        </div>
                      </label>
                      <div className="col-5 ">
                        <input
                          required
                          onChange={(e) => {
                            setSellArbitragePres(e.target.value);
                          }}
                          type="number"
                          className="form-control"
                          step="0.0001"
                          value={sellArbitragePres}
                          min="-100"
                          max="100"
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="offset-1 col-6 text-left col-form-label tooltipMy ">
                        Sell Arbitrage Percentage Taker (%)
                        <span role="img" aria-label="info">
                          &#10068;
                        </span>
                        <div className="tooltiptextmy">
                          <span>
                            If Nash price and global price gap is greater than
                            this amount bot will place taker limit sell order.{" "}
                            <br />
                          </span>
                        </div>
                      </label>
                      <div className="col-5 ">
                        <input
                          required
                          onChange={(e) => {
                            setSellTakerArbitragePres(e.target.value);
                          }}
                          type="number"
                          className="form-control"
                          step="0.0001"
                          value={sellTakerArbitragePres}
                          min="-100"
                          max="100"
                        />
                      </div>
                    </div>
                  </React.Fragment>
                )}
                {strategy === "EMA-MA-CROSSOVER" && (
                  <div className="form-group row">
                    <label className="offset-1 col-6 text-left col-form-label tooltipMy ">
                      Sell Only Buys
                      <span role="img" aria-label="info">
                        &#10068;
                      </span>
                      <div className="tooltiptextmy">
                        <span>
                          If this field checked bot wouldn't sell more than it
                          bought.
                        </span>
                      </div>
                    </label>
                    <div className="col-3 form-check p-2 pr-3 m-auto text-left">
                      <input
                        type="checkbox"
                        className="pr-3 mr-3 "
                        // style={{ fontSize: "1.5rem" }}

                        checked={isSellAfterBuy}
                        onChange={(e) => {
                          setSellAfterBuy(e.target.checked);
                        }}
                      />
                    </div>
                  </div>
                )}
                {strategy === "MARKET-MAKER-RSI" && (
                  <React.Fragment>
                    <div className="form-group row">
                      <label className="offset-1 col-6 text-left col-form-label tooltipMy ">
                        Max {marketData.baseAsset.toUpperCase()} Buy (
                        {marketData.quoteAsset.toUpperCase()})
                        <span role="img" aria-label="info">
                          &#10068;
                        </span>
                        <div className="tooltiptextmy">
                          <span>
                            Bot wouldn't buy more than that amount worth of{" "}
                            {marketData.baseAsset.toUpperCase()}.
                          </span>
                        </div>
                      </label>
                      <div className="col-5 ">
                        <input
                          required
                          onChange={(e) => {
                            setmaxBuy(e.target.value);
                          }}
                          step="0.0001"
                          type="number"
                          className="form-control"
                          value={maxBuy}
                          min="0"
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="offset-1 col-6 text-left col-form-label tooltipMy ">
                        Sell Only Buys
                        <span role="img" aria-label="info">
                          &#10068;
                        </span>
                        <div className="tooltiptextmy">
                          <span>
                            If this field checked bot wouldn't sell more than it
                            bought.
                          </span>
                        </div>
                      </label>
                      <div className="col-3 form-check p-2 pr-3 m-auto text-left">
                        <input
                          type="checkbox"
                          className="pr-3 mr-3 "
                          // style={{ fontSize: "1.5rem" }}

                          checked={isSellAfterBuy}
                          onChange={(e) => {
                            setSellAfterBuy(e.target.checked);
                          }}
                        />
                      </div>
                    </div>
                  </React.Fragment>
                )}
              </div>
            </div>
            {strategy !== "BINANCE-ARB" && strategy !== "KUCOIN-ARB" && (
              <div className="form-group row">
                <div className="col-12 border border-black rounded-lg pt-4 componentWrapper">
                  <div className="header">StopLoss Settings</div>
                  <div className="form-group row">
                    <label
                      className="col-6 col-form-label tooltipMy"
                      htmlFor="setStopLoss"
                    >
                      Set StopLoss{" "}
                      <span role="img" aria-label="info">
                        &#10068;
                      </span>
                      <div className="tooltiptextmy">
                        <span>
                          If type buy and price drops more than your stop loss
                          price. It excute market sell order and exit.
                          <br />
                          <br />
                          Stop loss price calculate from your first order. If it
                          reached it cancel all orders including extra orders
                          and execute market order for total amount to exit.
                        </span>
                      </div>
                    </label>
                    <div className="col-3 form-check p-2 pr-3 m-auto text-left">
                      <input
                        type="checkbox"
                        className="pr-3 mr-3 "
                        // style={{ fontSize: "1.5rem" }}
                        id="setStopLoss"
                        checked={isStopLossSet}
                        onChange={(e) => {
                          setIsStopLossSet(e.target.checked);
                        }}
                      />
                    </div>
                  </div>

                  {isStopLossSet && (
                    <div className="form-group row">
                      <label className=" offset-1 col-6 col-form-label tooltipMy">
                        StopLoss (%){" "}
                        <span role="img" aria-label="info">
                          &#10068;
                        </span>
                        <div className="tooltiptextmy">
                          <span>
                            If type buy and price drops more than your stop loss
                            price. It excute market sell order and exit.
                            <br />
                            <br />
                            Stop loss price calculate from your first order. If
                            it reached it cancel all orders including extra
                            orders and execute market order for total amount to
                            exit.
                          </span>
                        </div>
                      </label>
                      <div className="col-5">
                        <input
                          required={isStopLossSet}
                          onChange={(e) => {
                            setStopLoss(e.target.value);
                          }}
                          type="number"
                          step="0.0001"
                          className="form-control"
                          min="0.0001"
                          value={stopLoss}
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}
            {strategy !== "BINANCE-ARB" &&
              strategy !== "KUCOIN-ARB" &&
              strategy !== "MARKET-MAKER" &&
              strategy !== "MARKET-MAKER-RSI" &&
              strategy !== "EMA-MA-CROSSOVER" && (
                <div className="form-group row">
                  <div className="col-12 border border-black rounded-lg pt-4 componentWrapper">
                    <div className="header">Extra Orders Settings</div>
                    <div className="form-group row">
                      <label className="col-7 col-form-label tooltipMy">
                        Type{" "}
                        <span role="img" aria-label="info">
                          &#10068;
                        </span>
                        <div className="tooltiptextmy">
                          <span>
                            <strong>DCA bots -</strong> If extra order filled it
                            cancel previous take profit order and place new take
                            profit order with average take profit price for
                            total trade amount.
                            <br />
                            <br />
                            <strong>Grid bots -</strong> Each extra order has
                            separate take profit orders as your takeProfit
                            presentage.
                          </span>
                        </div>
                      </label>
                      <div className="col-5">
                        <select
                          required
                          onChange={(e) => {
                            setDcaOrGrid(e.target.value);
                          }}
                          className="custom-select mr-sm-2"
                          defaultValue={"DCA"}
                        >
                          <option value="DCA">DCA</option>
                          <option value="GRID">Grid</option>
                        </select>
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-7 col-form-label tooltipMy">
                        Max extra orders{" "}
                        <span role="img" aria-label="info">
                          &#10068;
                        </span>
                        <div className="tooltiptextmy">
                          <span>
                            Number of extra orders place by bot. <br />
                            After your first order filled bot will place extra
                            order until your max extra order limit reached.{" "}
                            <br />
                            <br />
                            If your order size is $10 and you set 3 extra orders
                            bot will place total 4 order. So you need total $40
                            in your funds.
                          </span>
                        </div>
                      </label>
                      <div className="col-5">
                        <input
                          required
                          onChange={(e) => {
                            setMaxExOrders(e.target.value);
                          }}
                          type="number"
                          className="form-control"
                          value={maxExtraOrders}
                          min="0"
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-7 col-form-label tooltipMy">
                        Active extra orders{" "}
                        <span role="img" aria-label="info">
                          &#10068;
                        </span>
                        <div className="tooltiptextmy">
                          <span>
                            Number of active extra orders place by bot. <br />
                            After your first order filled bot place extra orders
                            until your active extra orders limit or your max
                            extra order limit reached. <br />
                            <br />
                            If you set 5 extra orders and 3 active orders, after
                            your first order filled bot will place 3 open extra
                            orders. if any of extra order filled bot place
                            another extra order until your max extra order limit
                            hit.
                          </span>
                        </div>
                      </label>
                      <div className="col-5">
                        <input
                          required
                          onChange={(e) => {
                            setActiveExOrders(e.target.value);
                          }}
                          type="number"
                          className="form-control"
                          value={activeExtraOrders}
                          min={parseFloat(maxExtraOrders) === 0 ? "0" : "1"}
                          max={maxExtraOrders.toString()}
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-7 col-form-label tooltipMy">
                        Step of extra order (%){" "}
                        <span role="img" aria-label="info">
                          &#10068;
                        </span>
                        <div className="tooltiptextmy">
                          <span>
                            If your type buy, max orders count is 2 and step of
                            extra order is 1%.
                            <br /> After first buy order filled if price dropped
                            more than 1% of first buy price, bot will place
                            extra buy order. If price drop another 1% bot will
                            place another buy order. So then your max extra
                            order count is reached and bot will wait until
                            existing take profit order to complete, before place
                            new order.
                          </span>
                        </div>
                      </label>
                      <div className="col-5">
                        <input
                          required
                          onChange={(e) => {
                            setStepExOrder(e.target.value);
                          }}
                          type="number"
                          step="0.0001"
                          className="form-control"
                          min="0.0001"
                          value={stepOfExtraOrder}
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-7 col-form-label tooltipMy">
                        Multiplier
                        <span role="img" aria-label="info">
                          &#10068;
                        </span>
                        <div className="tooltiptextmy">
                          <span>
                            Each extra order's order size will multiply by this
                            value. <br />
                            As a example if your ordersize is $10 and multiplier
                            is 2, order size of first extra order is $20, order
                            size of second extra order is $40.
                          </span>
                        </div>
                      </label>
                      <div className="col-5">
                        <input
                          required
                          onChange={(e) => {
                            setMultiplier(e.target.value);
                          }}
                          type="number"
                          step="0.0001"
                          className="form-control"
                          min="0.0001"
                          value={multiplier}
                        />
                      </div>
                    </div>
                  </div>{" "}
                </div>
              )}
            {strategy !== "BINANCE-ARB" &&
              strategy !== "KUCOIN-ARB" &&
              strategy !== "MARKET-MAKER" &&
              strategy !== "MARKET-MAKER-RSI" && (
                <div className="form-group row">
                  <label className="col-7 col-form-label tooltipMy">
                    Total Assets Need (
                    {type === "BUY"
                      ? marketData.quoteAsset.toUpperCase()
                      : marketData.baseAsset.toUpperCase()}
                    )
                    <span role="img" aria-label="info">
                      &#10068;
                    </span>
                    <div className="tooltiptextmy">
                      <span>
                        Total assets need to available in your trading account.
                      </span>
                    </div>
                  </label>
                  <div className="col-5">
                    <input
                      disabled={true}
                      type="number"
                      className="form-control"
                      value={getTotalCapital()}
                    />
                  </div>
                </div>
              )}
            <div className="form-group row">
              <div className="col-sm-8 m-auto col-12">
                <div className="row">
                  <div className="col-4 text-center verticalCenter">
                    <Link
                      to="/account/createbot"
                      // type="submit"
                      className="btn btn-secondary w-100"
                    >
                      Back
                    </Link>
                  </div>
                  <div className="col-4 text-center verticalCenter">
                    <button
                      className="btn btn-primary w-100"
                      type="submit"
                      onClick={() => setSubmitType("save")}
                    >
                      Save
                    </button>
                  </div>
                  <div className="col-4 text-left">
                    <button
                      disabled={isRestricted}
                      onClick={() => setSubmitType("start")}
                      type="submit"
                      className="btn btn-success w-100"
                    >
                      Save & Start
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  botsCount: state.botsCount.botsCount,
});

export default withRouter(connect(mapStateToProps)(CreateBotAdvanced));
